
import BlogTextColor from '~/components/Common/Blog/BlogTextColor'

export default {
    name: 'China',
    components: { BlogTextColor },
}
